import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({ current_password: "", new_password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", form);
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "" });
      onOpenChange(false);
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Current password</Label><Input data-testid="current-password-input" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required /></div>
          <div><Label>New password (min 6)</Label><Input data-testid="new-password-input" type="password" minLength={6} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required /></div>
          <DialogFooter><Button data-testid="change-password-submit" type="submit" className="bg-red-600 hover:bg-red-700">Update password</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
